import {
  getDocumentaryDossiersSearch,
  getGetDocumentaryDossiersSearchQueryKey
} from 'client/api/backend/documentary-dossiers/documentary-dossiers';
import { GetDocumentaryDossiersSearchParams } from 'client/api/backend/schemas';
import { ErrorType } from 'client/core/network/mutators/apiClient';
import {
  QueryFunction,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any;

export const InfiniteDossiersSearchPageStart = 0;

export const useInfiniteDossiersSearch = <
  TData = AsyncReturnType<typeof getDocumentaryDossiersSearch>,
  TError = ErrorType<void>
>(
  params?: GetDocumentaryDossiersSearchParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      AsyncReturnType<typeof getDocumentaryDossiersSearch>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options || {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentaryDossiersSearchQueryKey(params);

  const queryFn: QueryFunction<
    AsyncReturnType<typeof getDocumentaryDossiersSearch>
  > = ctx =>
    getDocumentaryDossiersSearch({
      ...params!,
      pageNumber: ctx.pageParam ?? InfiniteDossiersSearchPageStart
    });

  const query = useInfiniteQuery<
    AsyncReturnType<typeof getDocumentaryDossiersSearch>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions);

  return {
    queryKey,
    ...query
  };
};
